module.exports = __webpack_public_path__ + "img/合规生产类.550218cd.png";